import Image from '@/models/image';
import {BuyXGetYProductProps} from '@/interfaces/models/buyXGetYProduct';

export default class BuyXGetYProduct {
  public id: string;
  public cost: number;
  public description: string;
  public image: Image;
  public title: string;
  public weight: string;

  [key: string]: any;

  public constructor(
    id: string,
    cost: number,
    description: string,
    image: Image,
    title: string,
    weight: string,
  ) {
    this.id = id;
    this.cost = cost;
    this.description = description;
    this.image = image;
    this.title = title;
    this.weight = weight;
  }

  public static createFromRequest(productProps: BuyXGetYProductProps): BuyXGetYProduct {
    const image = productProps.image ? new Image(productProps.image) : new Image();

    return new BuyXGetYProduct(
      productProps.id,
      productProps.cost,
      productProps.description,
      image,
      productProps.title,
      productProps.weight,
    );
  }
}
